// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"fa976023","348":"64292eda","417":"3356c8ed","444":"4d371a61","505":"81c29c16","589":"13cad804","629":"6f5d961e","983":"a25c57af"}[chunkId] + ".chunk.js";
};